import m from "../../geodata/es2015/centralAfricanRepublicHigh";
window.am4geodata_centralAfricanRepublicHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/centralAfricanRepublicHigh.js
// module id = null
// module chunks = 